// extracted by mini-css-extract-plugin
module.exports = {"reportHistory":"ReportHistory_reportHistory__2Ge1p","content":"ReportHistory_content__3qni0","buttonsContainer":"ReportHistory_buttonsContainer__LwRlU"};